import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import ModalDialog from 'garaje/components/ui/classic/modal-dialog';
import type UserDocumentModel from 'garaje/models/user-document';
import resolveSync from 'garaje/utils/resolve-sync';

interface AttachmentDisplay {
  altText: string;
  fileUrl: string | null;
}

interface UserDocumentListModalSignature {
  Args: {
    toggleOpen: () => void;
    userDocument: UserDocumentModel;
  };
}

export default class UserDocumentListModal extends Component<UserDocumentListModalSignature> {
  get sortedAttachments(): AttachmentDisplay[] {
    const attachments = this.args.userDocument.userDocumentAttachments.content;
    if (!attachments?.length) return [];
    return [...attachments]
      .sort((a, b) => {
        const aPos = resolveSync(a.userDocumentTemplateAttachment)?.position ?? 0;
        const bPos = resolveSync(b.userDocumentTemplateAttachment)?.position ?? 0;
        return aPos - bPos;
      })
      .map((attachment) => ({
        altText: resolveSync(attachment.userDocumentTemplateAttachment)?.title ?? '',
        fileUrl: attachment.fileUrl,
      }));
  }

  <template>
    <ModalDialog
      @clickOutsideToClose={{true}}
      @onClose={{@toggleOpen}}
      @containerClassNames="ember-modal-dialog--black text-center ember-modal-dialog--lightbox"
      @targetAttachment="center"
      @translucentOverlay={{true}}
    >
      <a
        data-test-close-view-user-document
        class="h-8 w-8 text-2xl leading-normal text-center bg-white rounded text-black absolute right-4 top-4 overflow-hidden hover:no-underline focus:outline-none box-content"
        {{on "click" @toggleOpen}}
      >
        <span aria-hidden="true">&times;</span>
        <span class="sr-only">Close</span>
      </a>
      {{#each this.sortedAttachments as |attachment|}}
        <img
          data-private
          data-test-document-attachment-file
          src={{attachment.fileUrl}}
          alt={{attachment.altText}}
          height="330"
        />
      {{/each}}
    </ModalDialog>
  </template>
}
